<template>
    <div v-if="isVisible" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Transaction Type</h5>
          <button class="modal-close" @click="closeModal">&times;</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="updateTransactionType">
            <kt-form-row>
              <kt-col xs="12" sm="6" md="6">
                <kt-form-group>
                  <kt-form-label for="transaction_type">
                    {{ $t("accounting.label.please_select_transaction_type") }}
                    <select size="1" id="transaction_type" class="form-control" v-model="selectedType">
                      <option v-for="(type, key) in TRANSACTION_TYPES" :key="key" :value="key">
                        {{ TRANSACTION_TYPES_STR.get(type) }}
                      </option>
                    </select>
                  </kt-form-label>
                </kt-form-group>
              </kt-col>
            </kt-form-row>
            <kt-row>
              <kt-col xs="12" sm="6" md="6">
                <button type="submit" class="btn btn-success btn-wide float-left">
                  {{ $t('accounting.save_changes') }}
                </button>
              </kt-col>
            </kt-row>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { accountingService } from "@/common/api.service";
  import { TRANSACTION_TYPES, TRANSACTION_TYPES_STR } from "@/constants/accountingTransactionType";
import { starShopAccountingService } from "../../../common/api.service";
  
  export default {
    props: {
      row: {
        type: Object,
        required: true
      },
      isVisible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selectedType: this.row.type,
        TRANSACTION_TYPES,
        TRANSACTION_TYPES_STR
      };
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },
      async updateTransactionType() {
        try {
          await starShopAccountingService.updateTransactionType(this.row.id, { type: this.selectedType }).then(
            response => {
              this.toastr.success(response.data.message)
              this.closeModal();
            },
            error => {
                    this.toastr.error(error.response.data.message || "An error occurred while deleting the account.");
                }
          );
        } catch (error) {
          console.error('Failed to update transaction type:', error);
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 80%;
    max-width: 500px;
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .modal-close {
    cursor: pointer;
    font-size: 24px;
  }
  </style>
  